import { useLayoutEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

const SCROLL_STORAGE_PREFIX = 'scroll-position:'
const HOME_PATHNAME = '/'

function getStorageKey(locationKey: string) {
  return `${SCROLL_STORAGE_PREFIX}${locationKey}`
}

export function useHistoryScrollRestoration() {
  const location = useLocation()
  const navigationType = useNavigationType()

  useLayoutEffect(() => {
    const currentLocationKey = location.key
    const isHomeRoute = location.pathname === HOME_PATHNAME

    if (isHomeRoute) {
      if (navigationType === 'POP') {
        const storedScrollPosition = sessionStorage.getItem(getStorageKey(currentLocationKey))
        if (storedScrollPosition !== null) {
          const parsedScrollPosition = Number.parseFloat(storedScrollPosition)
          if (!Number.isNaN(parsedScrollPosition)) {
            window.scrollTo({ top: parsedScrollPosition, left: 0, behavior: 'auto' })
          }
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
        }
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      }
    }

    return () => {
      if (isHomeRoute) {
        sessionStorage.setItem(getStorageKey(currentLocationKey), String(window.scrollY))
      }
    }
  }, [location.key, location.pathname, navigationType])
}
